import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router, NavigationStart, NavigationEnd} from '@angular/router';
import {Subscription} from 'rxjs';
import {SearchService} from '../../../../services/search.service';
import { Location } from '@angular/common';

@Component({
    selector: 'indiapicture-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit, OnDestroy {

    /** Set by the header on `/ai`: Pricing moves out of the nav there. */
    @Input() aiStudio = false;

    current = '';
    category = 'creative';

    private subscr: Subscription;

    constructor(private router: Router, private searchService: SearchService, location: Location) {

        // this.current = this.router.url;
     //  console.log('currenyt url 0 ',this.router.url);
        this.current =  this.router.url;
        this.subscr = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.current =  event.url;
             //  console.log('current 1 ',  event.url);
            } else if (event instanceof NavigationEnd) {
                this.current = event.url;
             //  console.log('current 2 ',  event.url);

            }
        });
    }

    ngOnInit(): void {
        // this.current = this.router.url;

        this.searchService = SearchService.getInstance();
        this.searchService.category.subscribe(category => {
            this.category = category;
         //  console.log('category ' ,this.category);
        });
    }

    ngOnDestroy(): void {
        this.subscr.unsubscribe();
    }

    viewAllDemos(event: any) {
        event.preventDefault();
        var list = document.querySelectorAll('.demo-list .hidden');
        for (let i = 0; i < list.length; i++) {
            list[i].classList.add('show');
        }

        event.target.parentElement.classList.add('d-none');
    }
}
